import Multiselect from './multiselect';
export default Multiselect;